import { render, staticRenderFns } from "./SelectLGA.vue?vue&type=template&id=4a79d331&"
import script from "./SelectLGA.vue?vue&type=script&lang=js&"
export * from "./SelectLGA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports